import { computed, observable, makeObservable } from "mobx";
import { startCase } from "../utils/string";
import { IUserResponse } from "./apiResponses";
import { IDistrict, ISchool } from "./apiDataStructures";

export interface IGroup {
  name: string;
}

export class User {
  id: number | undefined;
  username: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  groups: IGroup[] | undefined;
  districts: IDistrict[] | undefined;
  schools: ISchool[] | undefined;
  districtContentEnabled = false;
  schoolContentEnabled = false;

  isEducator = false;
  isApplicationAdmin = false;
  isAppAdmin = false;
  isDistrictAdmin = false;
  isSchoolAdmin = false;
  isParentResourceOnlyUser = false;

  constructor(options: Partial<IUserResponse> = {}) {
    makeObservable(this, {
      id: observable,
      username: observable,
      firstName: observable,
      lastName: observable,
      email: observable,
      groups: observable,
      districts: observable,
      schools: observable,
      districtContentEnabled: observable,
      schoolContentEnabled: observable,
      isEducator: observable,
      isApplicationAdmin: observable,
      isAppAdmin: observable,
      isDistrictAdmin: observable,
      isSchoolAdmin: observable,
      isParentResourceOnlyUser: observable,
      displayName: computed
    });

    Object.assign(this, options);
    this.isApplicationAdmin = this.hasRole("APPLICATION_ADMIN");
    // this.isEducator = this.hasRole("EDUCATOR");
    // this.isSchoolAdmin = this.hasRole("SCHOOL_ADMIN");
    this.firstName = startCase(options.firstName || "");
    this.lastName = startCase(options.lastName || "");
  }

  get displayName() {
    return this.firstName
      ? `${this.firstName} ${this.lastName}`
      : this.username;
  }

  hasRole(roleName: string): boolean {
    if (!this.groups) {
      return false;
    }
    return this.groups.findIndex(group => group.name === roleName) > -1;
  }

  update(options: Partial<IUserResponse> = {}) {
    Object.assign(this, options);
  }
}
